import styled from 'styled-components';
import { ArrowIcon } from '../Icons';

export const Container = styled.div`
  background: ${(props) => props.theme.colors.backgroundColorcomponent};
  border-radius: 15px;
  width: 100%;
  display: flex;
  flex-direction: row;
  padding: 16px;
  align-items: center;
`;

export const Title = styled.h2`
  font-size: 1.6rem;
  color: ${(props) => props.theme.colors.cartTitleColor};
  padding-bottom: 8px;
  font-weight: normal;
  padding: 0px;
  flex: 1;
`;

export const Action = styled.div`
  width: 200px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  cursor: pointer;

  * {
    color: rgb(0, 198, 201);
  }
`;

export const ActionText = styled.span`
  font-size: 1.2rem;
`;

export const ActionIcon = styled(ArrowIcon)`
  color: rgb(0, 198, 201);
`;
